/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Sync_CompleteInputs */

const en_booking_sync_complete = /** @type {(inputs: Booking_Sync_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taken by the platform`)
};

/**
* | output |
* | --- |
* | "Taken by the platform" |
*
* @param {Booking_Sync_CompleteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const booking_sync_complete = /** @type {((inputs?: Booking_Sync_CompleteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Sync_CompleteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_booking_sync_complete(inputs)
});